<template>
    <div class="main">
        <div>
            <h1 class="display-2">404</h1>
            <h1 class="display-3">Page not Found</h1>
        </div>
        <!-- <a class="btn btn-outline-info" href="javascript:history.back()">Go Back</a> -->
        <router-link class="btn btn-outline-info btn-lg" to="/">Back to the Dashboard</router-link>
    </div>
</template>

<script>
export default {
    //
}
</script>

<style lang="sass" scoped>
    .main
        min-height: 40vh
        display: flex
        flex-direction: column
        justify-content: space-around
        align-items: center
        & div
            display: flex
            flex-direction: column
            align-items: center
</style>





// WEBPACK FOOTER //
// src/components/pages/not-found/not-found.vue